module.exports = __webpack_public_path__ + "static/img/mysql.07c28ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mysql.png
// module id = j9Sz
// module chunks = 1